import { findParamInLocalStorage } from "./getAnyDataLocalStorge";
/**
 * Detecta si el flujo actual es "Vida Activa" buscando el page-action-flag
 * `afy-isVidaProtegida` en localStorage.afy-action-flags.
 *
 * Si el flag existe, el flujo es Vida Activa (retorna true);
 * si no existe, retorna false.
 */
export var isVidaActiva = function () {
    try {
        var actionFlags = findParamInLocalStorage("", "afy-action-flags");
        if (!Array.isArray(actionFlags))
            return false;
        return actionFlags.some(function (flag) { return (flag === null || flag === void 0 ? void 0 : flag.name) === "afy-isVidaActiva"; });
    }
    catch (_a) {
        return false;
    }
};
